import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ChevronDownGlyph = /*#__PURE__*/createElement("g", {
  id: "arrow"
}, /*#__PURE__*/createElement("path", {
  d: "M65.7,32.6c-0.6-0.6-1.5-0.6-2.1,0L42,54.2L20.4,32.6c-0.6-0.6-1.5-0.6-2.1,0s-0.6,1.5,0,2.1l22.6,22.6 c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4l22.6-22.6C66.3,34.2,66.3,33.2,65.7,32.6z"
}));
const ChevronDown = createSvg({
  name: 'chevron-down',
  path: ChevronDownGlyph
});

export default ChevronDown;
export { ChevronDownGlyph };
